export const EmptyPage = {
    pageId: undefined,
    pageName: '',
    pageURL: '',
    user_Added_by: undefined,
    description: ''
}